// @ts-nocheck
"use client";
import Script from "next/script";

const HubSpotTrackingScript = () => {
    return (
        <Script
            id="hs-script-loader"
            src="//js-na2.hs-scripts.com/6864149.js"
            strategy="lazyOnload"
        />
    );
};

export default HubSpotTrackingScript;
